import styled from 'styled-components';

export const UiHeader = styled.div`
	display: flex;
	justify-content: flex-end;
`;